// import React, { useState, useRef, useEffect } from 'react';
// import { isNil } from 'lodash';
// import { connect } from 'react-redux';
// import './index.css';

// const RenderMarkers = (props) => {
//   const { markers, mapReference, auth } = props;
//   const mapFunction = async (toAdd) => {
//     let { AdvancedMarkerElement } = await window.google.maps.importLibrary("marker");

//     if (!isNil(mapReference) && toAdd.length > 0) {
//       toAdd.forEach(marker => {

//         const url = 'https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/landtrust.png';

//         const img = document.createElement('img');
//         img.src = url;
//         img.style.width = '40px';
//         img.style.height = '40px';

//         const mapObj = new AdvancedMarkerElement({
//           map: mapReference,
//           content: img,
//           position: { lat: marker.latitude, lng: marker.longitude },
//           title: marker.title,
//           id: marker.id
//         });

//         marker['measureType'] = 'marker';
//         marker['mapObj'] = function () { return mapObj; };

//         let mapListner = mapObj.addListener('click', handleClick);

//         function handleClick() {
//           console.log('clicked on marker')
//           //  expandLeftToolbar({ dialog: 'edit', editable: marker, mapObj: mapListner })
//         }
//       });
//     }
//   };


//   const toAdd = markers

//   if (toAdd.length > 0) {
//     mapFunction(toAdd);
//   }

// };

// const mapStateToProps = state => ({
//   mapReference: typeof state.landTrustMapReference === 'function' ? state.landTrustMapReference() : null,
//   markers: state.privateLandItems,
//   auth: state.auth,
// });

// const mapDispatchToProps = dispatch => ({

// });

// export default connect(mapStateToProps, mapDispatchToProps)(RenderMarkers);



// const mapFunction = async (toAdd) => {
//   const { AdvancedMarkerElement } = await window.google.maps.importLibrary("marker");

//   const markersToAdd = [];

//   toAdd.forEach((rawMarker) => {
//     const marker = { ...rawMarker }; // clone to avoid Redux mutation

//     const url = 'https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/landtrust.png';

//     const img = document.createElement('img');
//     img.src = url;
//     img.style.width = '40px';
//     img.style.height = '40px';

//     const mapObj = new AdvancedMarkerElement({
//       map: mapReference,
//       content: img,
//       position: { lat: marker.latitude, lng: marker.longitude },
//       title: marker.title,
//       id: marker.id
//     });

//     marker['measureType'] = 'marker';
//     marker['mapObj'] = () => mapObj;

//     function handleClick() {
//       console.log('clicked on marker');
//     }

//     mapObj.addListener('click', handleClick);

//     markerRefs.current[marker.id] = mapObj;
//     markersToAdd.push(marker); // store full enriched marker
//   });

//   markerClusterRef.current = new MarkerClusterer({
//     map: mapReference,
//     markers: markersToAdd.map(m => m.mapObj()),
//     renderer: customRenderer,
//   });

//   // ✅ Dispatch the enriched markers with mapObj
//   fetchPrivateAddMarkersAction(markersToAdd);
// };










// import React, { useState, useRef, useEffect } from 'react';
// import { connect } from 'react-redux';
// import './index.css';
// import { MarkerClusterer } from "@googlemaps/markerclusterer";
// import { fetchPrivateAddMarkersAction, fetchPrivateRemoveMarkersAction } from '../../../action/private-land-markers';

// const RenderMarkers = (props) => {

//   const markerRefs = useRef({});
//   const markerClusterRef = useRef(null);

//   const {
//     markers,
//     mapReference,
//   } = props;


//   const customRenderer = {
//     render({ count, position }) {
//       const div = document.createElement('div');
//       div.className = 'pt-custom-cluster';
//       div.textContent = count;
//       return new google.maps.marker.AdvancedMarkerElement({
//         position,
//         content: div,
//       });
//     },
//   };

//   const mapFunction = async (toAdd) => {
//     const { AdvancedMarkerElement } = await window.google.maps.importLibrary("marker");

//     const markersToAdd = [];

//     toAdd.forEach((rawMarker) => {
//       const marker = { ...rawMarker }; // clone to avoid Redux mutation

//       const url = 'https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/landtrust.png';

//       const img = document.createElement('img');
//       img.src = url;
//       img.style.width = '40px';
//       img.style.height = '40px';

//       const mapObj = new AdvancedMarkerElement({
//         map: mapReference,
//         content: img,
//         position: { lat: marker.latitude, lng: marker.longitude },
//         title: marker.title,
//         id: marker.id
//       });

//       marker['measureType'] = 'marker';
//       marker['mapObj'] = function () { return mapObj; };

//       function handleClick() {
//         console.log('clicked on marker')
//         //  expandLeftToolbar({ dialog: 'edit', editable: marker, mapObj: mapListner })
//       }

//       mapObj.addListener('click', handleClick);

//       markerRefs.current[marker.id] = mapObj;
//       markersToAdd.push(mapObj);
//     });

//     markerClusterRef.current = new MarkerClusterer({
//       map: mapReference,
//       markers: markersToAdd,
//       renderer: customRenderer,
//     });

//     props.fetchPrivateAddMarkersAction(markersToAdd);

//   };

//   useEffect(() => {
//     if (mapReference) {
//       const toAdd = markers;
//       mapFunction(toAdd);
//     }
//   }, [markers]);



//    // ✅ Clear markers + clusters when Redux array is empty
//   useEffect(() => {
//     if (Array.isArray(privateLandsMarkersMapObj) && privateLandsMarkersMapObj.length === 0) {
//       // Clear clusterer
//       if (markerClusterRef.current) {
//         markerClusterRef.current.clearMarkers();
//         markerClusterRef.current = null;
//       }

//       // Remove individual markers from map
//       Object.values(markerRefs.current).forEach(marker => {
//         marker.map = null;
//       });

//       // Clear refs
//       markerRefs.current = {};
//     }
//   }, [privateLandsMarkersMapObj]);



//   return null;
// };

// const mapStateToProps = state => ({
//   mapReference: typeof state.landTrustMapReference === 'function' ? state.landTrustMapReference() : null,
//   markers: state.privateLandItems,
//   auth: state.auth,
//   privateLandsMarkersMapObj: state.privateLandsMarkersMapObj
// });

// const mapDispatchToProps = dispatch => ({
//   fetchPrivateAddMarkersAction: (payload) => dispatch(fetchPrivateAddMarkersAction(payload)),
//   fetchPrivateRemoveMarkersAction: (payload) => dispatch(fetchPrivateRemoveMarkersAction(payload))
// });

// export default connect(mapStateToProps, mapDispatchToProps)(RenderMarkers);



import React, { useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import './index.css';
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import {
  fetchPrivateAddMarkersAction,
  fetchPrivateRemoveMarkersAction
} from '../../../action/private-land-markers';
import { landTrustRightMenuBarOpen } from '../../../action/land-trust-menu-bar';



export const buildContent = () => {
  const content = document.createElement("div");
  content.classList.add("css-o1utut");
  content.innerHTML = `
   <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 319.7 421.8"
        class="css-1jzm98"
      >
        <path d="m0 0 .2 271.2a106 106 0 0 0 1.1 15.9 89.6 89.6 0 0 0 6.9 24.6c10.1 22.4 22 35.7 33.4 47 22.8 22.8 45.6 34.3 61.2 42.1a287.6 287.6 0 0 0 57 21 286.4 286.4 0 0 0 57.1-21c15.6-7.8 38.4-19.3 61.2-42.1 11.4-11.3 23.3-24.6 33.4-47a89.6 89.6 0 0 0 6.9-24.6 106 106 0 0 0 1.1-15.9L319.7 0zm290.4 29.3v80.1h-261V29.3zm-.1 178.6a163 163 0 0 0-22.1-5c-4.7-.7-23.5-3.5-50.1-.3-11.8 1.4-22.5 4-43.7 9.3-15.6 3.9-28.4 7.5-37.4 10.1-19.4 6.8-51.3 14.5-87.6 6.4a147.5 147.5 0 0 1-20-5.9v-83.8h260.9zm-83.8 165.8a227 227 0 0 1-46.7 17.1 228 228 0 0 1-46.6-17.1l-8.6-4.4 55.1-31.8 55.3 31.9zm83.7-104.9a79 79 0 0 1-.4 8.4 75.3 75.3 0 0 1-6.1 23.7c-8.2 18.4-18 29.2-27.3 38.4a156 156 0 0 1-13.2 11.9l-1.3-.8-82.2-47.4-82.1 47.4-1.2.7a172 172 0 0 1-13.1-11.8c-9.3-9.2-19.1-20-27.3-38.4a75.3 75.3 0 0 1-6.1-23.7 79 79 0 0 1-.4-8.4V253a160 160 0 0 0 21.8 4.9c4.6.7 23.5 3.5 50.1.3 11.8-1.4 22.4-4.1 43.7-9.3 15.6-3.9 28.4-7.5 37.4-10.1 19.4-6.8 51.2-14.5 87.6-6.4a145 145 0 0 1 20.1 6z"></path>
      </svg>
 `;
  return content;
}

const RenderMarkers = (props) => {
  const markerRefs = useRef({});
  const markerClusterRef = useRef(null);

  const {
    markers,
    mapReference,
    privateLandsMarkersMapObj,
    fetchPrivateAddMarkersAction,
    fetchPrivateRemoveMarkersAction,
    privateLandItems
  } = props;

  const customRenderer = {
    render({ count, position }) {
      const div = document.createElement('div');
      div.className = 'pt-custom-cluster';
      div.textContent = count;
      return new google.maps.marker.AdvancedMarkerElement({
        position,
        content: div,
      });
    },
  };

  const mapFunction = async (toAdd) => {
    const { AdvancedMarkerElement } = await window.google.maps.importLibrary("marker");
    const markersToAdd = [];

    toAdd.forEach((rawMarker) => {
      const marker = { ...rawMarker }; // clone to avoid Redux mutation

      const url = 'https://basemap-core.s3.us-west-2.amazonaws.com/markertypes/landtrust.png';
      const img = document.createElement('img');
      img.src = url;
      img.style.width = '40px';
      img.style.height = '40px';

      const mapObj = new AdvancedMarkerElement({
        map: mapReference,
        content: buildContent(),
        position: { lat: marker.latitude, lng: marker.longitude },
        title: marker.title,
        id: marker.id,
      });

      marker['measureType'] = 'marker';
      marker['mapObj'] = () => mapObj;

      mapObj.addListener('click', () => {
        // console.log('clicked on marker');
        props.landTrustRightMenuBarOpen({ mapData: mapObj, activityDetails: marker })
      });

      markerRefs.current[marker.id] = mapObj;
      markersToAdd.push(mapObj);
    });

    // Clear existing cluster before re-adding
    if (markerClusterRef.current) {
      markerClusterRef.current.clearMarkers();
    }

    markerClusterRef.current = new MarkerClusterer({
      map: mapReference,
      markers: markersToAdd,
      renderer: customRenderer,
    });

    // Store markers in Redux
    fetchPrivateAddMarkersAction(markersToAdd);
  };

  // 🚀 Load markers and clusters when markers change
  useEffect(() => {
    if (mapReference && markers?.length > 0) {
      mapFunction(markers);
    }
  }, [markers, mapReference]);

  // 🧹 Remove clusters and markers when privateLandsMarkersMapObj is empty
  useEffect(() => {
    if (Array.isArray(privateLandsMarkersMapObj) && privateLandsMarkersMapObj.length === 0) {
      if (markerClusterRef.current) {
        markerClusterRef.current.clearMarkers();
        markerClusterRef.current = null;
      }

      Object.values(markerRefs.current).forEach(marker => {
        marker.map = null;
      });

      markerRefs.current = {};

      // Optionally, tell Redux we removed all
      fetchPrivateRemoveMarkersAction([]);
    }
  }, [markers]);

  return null;
};

const mapStateToProps = (state) => ({
  mapReference: typeof state.landTrustMapReference === 'function' ? state.landTrustMapReference() : null,
  markers: state.privateLandItems,
  privateLandsMarkersMapObj: state.privateLandsMarkersMapObj,
});

const mapDispatchToProps = (dispatch) => ({
  fetchPrivateAddMarkersAction: (payload) => dispatch(fetchPrivateAddMarkersAction(payload)),
  fetchPrivateRemoveMarkersAction: (payload) => dispatch(fetchPrivateRemoveMarkersAction(payload)),
  landTrustRightMenuBarOpen: (paylod) => dispatch(landTrustRightMenuBarOpen(paylod))
});

export default connect(mapStateToProps, mapDispatchToProps)(RenderMarkers);
